module.exports = __webpack_public_path__ + "img/sec0_slide3.c3cc54ce.png";